import { coreApi } from '@cp/shared/api/core';
import { ApiTags } from '@cp/shared/api/core/const';
import { generateApiUrl } from '@common/api/configure';
import { ApiRoute } from '@common/api/route';
import { apiRouteMethodDict } from '@common/api/routeMethod';
import { ApiRouteBody } from '@common/api/routeBody';
import { ClientSubscriptionViewModel } from '@common/model/billing/clientSubscription/view';
import { ClientSubscriptionProcessingResult } from '@common/model/billing/clientSubscription';
import { PromocodeApiTags } from '@cp/entities/promocode/@x/subscription';

export const clientSubscriptionApi = coreApi
  .enhanceEndpoints({
    addTagTypes: [PromocodeApiTags.PromocodeUsages],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      startBillingSubscription: builder.mutation<ClientSubscriptionProcessingResult, ApiRouteBody[ApiRoute.ClientBillingSubscriptionStart]>(
        {
          query: (body) => ({
            url: generateApiUrl(ApiRoute.ClientBillingSubscriptionStart),
            method: apiRouteMethodDict[ApiRoute.ClientBillingSubscriptionStart],
            body,
          }),
          invalidatesTags: [ApiTags.ClientBillingSubscription, PromocodeApiTags.PromocodeUsages],
        },
      ),

      getBillingSubscription: builder.query<ClientSubscriptionViewModel, void>({
        query: () => ({
          url: generateApiUrl(ApiRoute.ClientBillingSubscriptionGet),
          method: apiRouteMethodDict[ApiRoute.ClientBillingSubscriptionGet],
        }),
        providesTags: [ApiTags.ClientBillingSubscription],
      }),

      stopBillingSubscription: builder.mutation<void, void>({
        query: () => ({
          url: generateApiUrl(ApiRoute.ClientBillingSubscriptionStop),
          method: apiRouteMethodDict[ApiRoute.ClientBillingSubscriptionStop],
        }),
        invalidatesTags: [ApiTags.ClientBillingSubscription],
      }),
    }),
  });
